import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UsersService } from '../../services/users.service';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog.component';

@Component({
  selector: 'app-rodo',
  standalone: false,
  templateUrl: './rodo.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./rodo.component.scss']
})
export class RodoComponent {
  loading = false;

  constructor(
    private usersService: UsersService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  deleteAccount(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: {
        title: 'Usunąć konto',
        message: 'Czy na pewno chcesz trwale usunąć swoje konto? Ta operacja nie może być cofnięta. Wszystkie twoje dane zostaną skasowane zgodnie z RODO.',
        confirmText: 'Usuń konto',
        cancelText: 'Anuluj'
      }
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.executeAccountDeletion();
      }
    });
  }

  private executeAccountDeletion(): void {
    this.loading = true;
    this.usersService.rodoForget().subscribe({
      next: () => {
        this.snackBar.open('Konto zostało usunięte. Zostaniesz wylogowany.', 'OK', {
          duration: 3000,
          panelClass: ['success-snackbar'],
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
        localStorage.removeItem('userCard');
        localStorage.removeItem('auth_token');
        this.loading = false;
        // Clear all localStorage
        localStorage.clear();
        // Redirect to login after a short delay
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 1500);
      },
      error: () => {
        this.loading = false;
        this.snackBar.open('Błąd podczas usuwania konta. Spróbuj ponownie.', 'OK', {
          duration: 4000,
          panelClass: ['error-snackbar'],
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
      }
    });
  }
}
